import { ApiService } from "../../../constants/ApiService";
import { HttpService } from "../../../constants/HTTPService";
import { NewIDataUploadItem } from "../../../interfaces/IDataUploadItem";
import { IForm } from "../../../interfaces/IForm";

export const getUserTesting = async () => {
  const data = HttpService.get(ApiService.testing.getTestingUser);
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const getListRequestType = async () => {
  const data = HttpService.get(ApiService.alesaForm.getListRequestType);
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const getListDocumentType = async () => {
  const data = HttpService.get(ApiService.alesaForm.getListDocumentType);
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const getListAreaLocation = async () => {
  const data = HttpService.post(
    ApiService.apiHc.getAreaLocation,
    JSON.stringify({
      AreaLocation: { LocationID: "", LocationHierarcyID: "" },
    })
  );
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const editForm = async (
  dataForm?: IForm,
  dataUpload?: NewIDataUploadItem[],
  requestID?: string,
  requestStatusID?: string,
  crrNumber?: string
) => {
  function convertData(inputData: NewIDataUploadItem[]) {
    return inputData.reduce((acc: any[], curr) => {
      const files = curr.files.map((file) => ({
        title: curr.title,
        fileType: curr.fileType,
        ...file,
      }));
      return [...acc, ...files];
    }, []);
  }
  const files = convertData(dataUpload || []);
  const data = HttpService.post(
    ApiService.alesaForm.editForm,
    JSON.stringify({
      CrrNumber: crrNumber,
      StartDateString: dataForm?.startDatePeriod,
      EndDateString: dataForm?.endDatePeriod,
      RequestDate: dataForm?.requestDate,
      POADate: dataForm?.dateOfPower,
      BinusianID: dataForm?.binusianID,
      BinusianName: dataForm?.binusianName,
      TitleAgreement: dataForm?.titleAgreement,
      Counterpart: dataForm?.counterPart,
      Signer: `${dataForm?.signer?.binusianIDEmail}#${dataForm?.signer?.name}`,
      DocumentTypeID: dataForm?.documentType,
      Area: dataForm?.area,
      DetailArea: dataForm?.address,
      ListDocument: files,
      RequestID: requestID,
      RequestStatusID: requestStatusID,
      RequestTypeID: dataForm?.requestType,
      Ext: dataForm?.extension,
    })
  );
  const dataAPI = (await data).data;

  return dataAPI;
};

export const getSingleDataRequest = async (requestID?: string) => {
  const data = HttpService.post(
    ApiService.alesaForm.getSingleDataRequest,
    JSON.stringify({
      RequestID: requestID,
    })
  );
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const getListUnderLevelStaff = async (binusianID?: string) => {
  const data = HttpService.post(
    ApiService.alesaForm.getListUnderLevelStaff,
    JSON.stringify({
      BinusianID: binusianID,
    })
  );
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const downloadSingleFile = async (
  documentName?: string,
  category?: string,
  requestID?: string,
  sharepointToken?: string
) => {
  const data = HttpService.post(
    ApiService.alesaForm.downloadSingleFile,
    JSON.stringify({
      DocumentName: documentName,
      Category: category,
      RequestID: requestID,
      SharepointToken: sharepointToken,
    })
  );
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const downloadFileComment = async (
  commentID?: string,
  requestID?: string,
  sharepointToken?: string
) => {
  const data = HttpService.post(
    ApiService.alesaForm.downloadFileComment,
    JSON.stringify({
      CommentID: commentID,
      RequestID: requestID,
      SharepointToken: sharepointToken,
    })
  );
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const getSharepointToken = async () => {
  const data = HttpService.get(ApiService.alesaForm.getSharepointToken);
  const dataAPI = (await data).data;

  return dataAPI.data;
};
